import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translation from "../data/translation.json";

i18n.use(initReactI18next).init({
  resources: translation,
  fallbackLng: "en",
  debug: false,
});

export default i18n;
